import ApiAccessDataTable from "./ApiAccessDataTable";

export default ApiAccessDataTable;